import { graphql, useStaticQuery } from "gatsby";

export default function useRestaurants() {
	const { allRestaurants } = useStaticQuery(graphql`
		query {
			allRestaurants: allMarkdownRemark(
				filter: { frontmatter: { show: { eq: true } } }
				sort: { frontmatter: { order: ASC } }
			) {
				...AllRestaurants
			}
		}

		fragment AllRestaurants on MarkdownRemarkConnection {
			nodes {
				...RestaurantFields
			}
		}

		fragment RestaurantFields on MarkdownRemark {
			fields {
				id
			}
			frontmatter {
				title {
					es
					en
				}
				description {
					es
					en
				}
				location {
					es
					en
				}
				stamp
				locationJp
				hours
				booking
				bookingGroupMin
				bookingPhone
				address
				gMapsLink
				gMapsEmbedLink
				cartaAPIKey
				videoStart
				gallery {
					description {
						en
						es
					}
					slides {
						title {
							en
							es
						}
						titleJp
						image
						text {
							en
							es
						}
					}
				}
				features {
					title {
						en
						es
					}
					titleJp
					image
					text {
						en
						es
					}
				}
			}
		}
	`);

	return allRestaurants?.nodes;
}
